// extracted by mini-css-extract-plugin
module.exports = {"siderCollapsedWidth":"40px","container":"container--lTArN","containerBody":"containerBody--1k7Vo","searchContent":"searchContent--1Iytz"};